var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showTable()
        ? _c("v-breadcrumbs", {
            attrs: { divider: "/", items: _vm.items },
            scopedSlots: _vm._u(
              [
                {
                  key: "item",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-breadcrumbs-item",
                        {
                          key: item.text,
                          attrs: {
                            disabled: item.disabled,
                            href: "/#/main/" + item.name
                          }
                        },
                        [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              2014115247
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticStyle: { display: "flex", "align-items": "center" },
          attrs: { nowrap: "" }
        },
        [
          _vm.showTable()
            ? _c("v-flex", { attrs: { xs10: "" } }, [
                _c(
                  "h3",
                  {
                    staticClass: "pa-3",
                    staticStyle: { "text-align": "left" }
                  },
                  [_vm._v(_vm._s(_vm.items[_vm.items.length - 1].text))]
                )
              ])
            : _c("v-flex", { attrs: { xs10: "" } }, [
                _vm._v("\n       \n    ")
              ]),
          _vm._v(" "),
          "employeeList" == _vm.items[_vm.items.length - 1].name
            ? _c("v-flex", { attrs: { md2: "" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "has",
                        rawName: "v-has",
                        value: "addEmployee",
                        expression: "'addEmployee'"
                      }
                    ],
                    staticClass: "v-has"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function($event) {
                            return _vm.jumpToNewPage(
                              _vm.items[_vm.items.length - 1].name
                            )
                          }
                        }
                      },
                      [_vm._v("\n          编制人员\n        ")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          "roleList" == _vm.items[_vm.items.length - 1].name
            ? _c("v-flex", { attrs: { md2: "" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "has",
                        rawName: "v-has",
                        value: "addRole",
                        expression: "'addRole'"
                      }
                    ],
                    staticClass: "v-has"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { margin: "10px 10px 10px 0" },
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function($event) {
                            return _vm.jumpToNewPage(
                              _vm.items[_vm.items.length - 1].name
                            )
                          }
                        }
                      },
                      [_vm._v("\n          编制职务岗位\n        ")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.items[_vm.items.length - 1].name == "vehicleManager"
            ? _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-plus" },
                      on: {
                        click: function($event) {
                          return _vm.jumpToNewPage(
                            _vm.items[_vm.items.length - 1].name
                          )
                        }
                      }
                    },
                    [_vm._v("申报资料\n      ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.items[_vm.items.length - 1].name == "experts"
            ? _c("v-flex", { attrs: { xs2: "" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "has",
                        rawName: "v-has",
                        value: "addExperts",
                        expression: "'addExperts'"
                      }
                    ]
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-plus" },
                        on: { click: _vm.addNewExperts }
                      },
                      [_vm._v("\n          编制专家\n        ")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.items[_vm.items.length - 1].name == "vehicleTypeList"
            ? _c("v-flex", { attrs: { xs2: "" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "has",
                        rawName: "v-has",
                        value: "addVehicleType",
                        expression: "'addVehicleType'"
                      }
                    ],
                    staticClass: "v-has"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function($event) {
                            return _vm.jumpToNewPage(
                              _vm.items[_vm.items.length - 1].name
                            )
                          }
                        }
                      },
                      [_vm._v("\n          编制车辆名称\n        ")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.items[_vm.items.length - 1].name == "vehicleMap"
            ? _c("v-flex", { attrs: { xs0: "" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "has",
                        rawName: "v-has",
                        value: "isVehicleList",
                        expression: "'isVehicleList'"
                      }
                    ],
                    staticClass: "v-has"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.$router.push("vehicleList")
                          }
                        }
                      },
                      [_vm._v("\n          车辆列表\n        ")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.items[_vm.items.length - 1].name == "auditEmpList"
            ? _c("v-flex", { attrs: { xs0: "" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "has",
                        rawName: "v-has",
                        value: "addAuditEmp",
                        expression: "'addAuditEmp'"
                      }
                    ],
                    staticClass: "v-has"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { margin: "10px 10px 10px 0" },
                        attrs: { icon: "el-icon-plus" },
                        on: { click: _vm.addNewAuditEmp }
                      },
                      [_vm._v("\n          编制审批人员\n        ")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.items[_vm.items.length - 1].text == "租赁设备管理"
            ? [
                _c(
                  "v-flex",
                  {
                    directives: [
                      {
                        name: "has",
                        rawName: "v-has",
                        value: "isBindList",
                        expression: "'isBindList'"
                      }
                    ],
                    attrs: { xs0: "" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "v-has" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.$router.push(
                                  "/main/rentVehicleManage/terminalList"
                                )
                              }
                            }
                          },
                          [_vm._v("\n            机汇云盒\n          ")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.items[_vm.items.length - 1].text == "设备汇总"
            ? [
                _c("v-flex", { attrs: { xs0: "" } }, [
                  _c(
                    "div",
                    { staticClass: "v-has" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$router.push(
                                "/main/vehicleArchives/terminalList"
                              )
                            }
                          }
                        },
                        [_vm._v("\n            机汇云盒\n          ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.items[_vm.items.length - 1].text == "电子围栏"
            ? [
                _c("v-flex", { attrs: { xs0: "" } }, [
                  _c(
                    "div",
                    { staticClass: "v-has" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$router.push(
                                "/main/electronicFenceList"
                              )
                            }
                          }
                        },
                        [_vm._v("\n            电子围栏列表\n          ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.items[_vm.items.length - 1].text == "设备台帐编制"
            ? [
                _c("v-flex", { attrs: { xs0: "" } }, [
                  _c(
                    "div",
                    { staticClass: "v-has" },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.$router.push(
                                "/main/vehicleAccountFixSearch/import"
                              )
                            }
                          }
                        },
                        [_vm._v("导入设备台帐")]
                      )
                    ],
                    1
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }